module.exports = __webpack_public_path__ + "static/media/ico-video-level1.b676210f.svg";